// SitePlaceDialog.tsx — Place / edit panel location on site plan

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';

export default function SitePlaceDialog() {
  const { project, ui, updateSite } = useShallowStore(s => ({
    project:    s.project,
    ui:         s.ui,
    updateSite: s.updateSite,
  }));

  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const site  = project?.site;

  const existing = site?.panels.find(p => p.panelId === panel?.id);
  const [x,     setX]     = useState(existing?.x ?? 0);
  const [y,     setY]     = useState(existing?.y ?? 0);
  const [angle, setAngle] = useState(existing?.angle ?? 0);

  if (!panel || !project) return null;

  function save() {
    const panels = site?.panels.filter(p => p.panelId !== panel!.id) ?? [];
    panels.push({ panelId: panel!.id, x, y, angle, rotation: angle });
    updateSite({ panels });
  }

  return (
    <DialogBase title={`Place Panel: ${panel.mpvar.panelMark}`} onOk={save}>
      <div className="dialog-row">
        <label className="dialog-label">X Position</label>
        <input className="dialog-input sm" type="number" value={x} step={1}
          onChange={e => setX(parseFloat(e.target.value))} />
        <span className="dialog-unit">ft</span>
      </div>
      <div className="dialog-row">
        <label className="dialog-label">Y Position</label>
        <input className="dialog-input sm" type="number" value={y} step={1}
          onChange={e => setY(parseFloat(e.target.value))} />
        <span className="dialog-unit">ft</span>
      </div>
      <div className="dialog-row">
        <label className="dialog-label">Rotation</label>
        <input className="dialog-input sm" type="number" value={angle} step={5}
          onChange={e => setAngle(parseFloat(e.target.value))} />
        <span className="dialog-unit">°</span>
      </div>
    </DialogBase>
  );
}
